import React from "react";
import {useSelector} from "react-redux";
import {GoogleSearchResults} from "./GoogleSearchResults";
import {ShutterStockResults} from "./ShutterStockResults";
import {uploaderSelector} from "../../../selectors";

const resultsSources = {
  "google-search": <GoogleSearchResults />,
  "shutterstock": <ShutterStockResults />
};

export function Results() {
  const {
    uploader: {source}
  } = useSelector((state) => ({
    uploader: uploaderSelector(state)
  }));
  return resultsSources[source];
}
